<div class="modal-header">
  <p class="modal-title"><strong>{{ header }}</strong></p>
    <button type="button" (click)="modal.dismiss()" class="btn-close" aria-label="Close"></button>

</div>
<form name="form" #f="ngForm" (ngSubmit)="sendMail(f)">
  <div class="modal-body mail-body activityemail">
    <div *ngIf="headerVisibilty" class="col-12 form-group ">
      <div class="row">
        <div class="col-sm-1"><label>To</label></div>
        <div class="col-sm-11">
          <ng-select [disabled]="!headerAccessiblity" name="toAddresses" [items]="toAdUsers | async"
            [typeahead]="tosearchInput$" bindLabel="userPrincipalName" bindValue="userPrincipalName" [(ngModel)]="tos"
            #toAddresses="ngModel" [ngClass]="{ 'is-invalid':toAddresses.invalid }" placeholder="Select item"
            [loading]="toShowLoader" multiple="true" required>
            <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
              <div><span>{{item.displayName}}</span></div>
              <div><span><small>{{item.userPrincipalName}}</small></span></div>
            </ng-template>
          </ng-select>

          <div *ngIf="toAddresses.invalid" class="invalid-feedback">
            <div *ngIf="toAddresses.errors.required">To Address is required</div>
            <div *ngIf="toAddresses.errors.pattern">
              Enter valid To address
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="headerVisibilty" class="col-12 form-group">
      <div class="row">
        <div class="col-sm-1">
          <label>Cc</label>
        </div>
        <div class="col-sm-11">
          <ng-select [disabled]="!headerAccessiblity" name="cc" [items]="ccAdUsers | async" [typeahead]="ccsearchInput$"
            bindLabel="userPrincipalName" bindValue="userPrincipalName" [(ngModel)]="ccs" #cc="ngModel"
            [ngClass]="{ 'is-invalid':cc.invalid }" placeholder="Select item" [loading]="ccShowLoader" multiple="true">
            <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
              <div><span>{{item.displayName}}</span></div>
              <div><span><small>{{item.userPrincipalName}}</small></span></div>
            </ng-template>
          </ng-select>
          <div *ngIf="f.submitted && cc.invalid" class="invalid-feedback">
            <div *ngIf="cc.errors.pattern">
              Enter valid CC
            </div>

          </div>
        </div>
      </div>
    </div>
    <div *ngIf="headerVisibilty" class="col-12 mt-3 form-group">
      <div class="row">
        <div class="col-sm-1"><label>Subject</label></div>
        <div class="col-sm-11">
          <input [disabled]="!headerAccessiblity" type="text" class="form-control form-control-sm" name="subject"
            [(ngModel)]="results.subject" #subject="ngModel"
            [ngClass]="{ 'is-invalid': f.submitted && subject.invalid }" required />
          <div *ngIf="f.submitted && subject.invalid" class="invalid-feedback">
            <div *ngIf="subject.errors.required">Subject is required</div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="col-12 mt-3 form-group" *ngIf="showMultipleTemps && results.activityTemplates?.length > 1">
            <div class="row">
                <div class="col-sm-1"><label>Templates</label></div>
                <div class="col-sm-11"><select name="activityTemplateId" class="form-control form-control-sm"
                        (change)="TemplateLoad($event)" [(ngModel)]="results.activityTemplateId"
                        #activityTemplateId="ngModel"
                        [ngClass]="{ 'is-invalid': activityTemplateId.invalid && (activityTemplateId.dirty || f.submitted) }"
                        required>
                        <option *ngFor="let temp of results.activityTemplates" [value]="temp.id">{{temp.name}}</option>
                    </select></div>
            </div>

        </div> -->

    <div *ngIf="showAttachments" class="col-12 mt-3 form-group">
      <label>Attachments</label>
      <div class="row col">
        <div *ngFor="let doc of results.attachments; let i = index"
          class="attachment m-1 d-flex p-1 justify-content-between align-items-center ">
          <div class="d-flex">
            <div title="Download" class="ml-2" (click)="downloadFile(doc)">
              <img src="design/images/paperclip.png" style="width: 20px;height:20px" alt="attachment">
            </div>
            <div class="mx-2 text-white">
              {{doc | replace }}
            </div>
          </div>
          <a class="me-2" (click)="removeAttachment(i)">
            <img src="design/images/cancel.png" style="width: 10px;height:10px" alt="remove">
          </a>
        </div>
        <div class="ml-3 font-weight-bold text-muted"
          *ngIf="results.attachments && results.attachments.length === 0 && uploadedFiles && uploadedFiles.length === 0 && newAttachments && newAttachments.length===0">
          No attachments available
        </div>
        <div *ngFor="let doc of newAttachments; let i = index"
        class="attachment m-1 d-flex p-1 justify-content-between align-items-center">
        <div class="d-flex">
          <div title="Download" class="ml-2" (click)="downloadAttachment(doc)">
            <img src="design/images/paperclip.png" class="cursor-pointer" style="width: 20px;height:20px"
              alt="attachment">
          </div>
          <div class="mx-2 text-white">
            {{doc.fileName | replace }}
          </div>
        </div>
        <a class="me-2" (click)="removeAttachment(doc)">
          <img src="design/images/cancel.png" class="cursor-pointer" style="width: 10px;height:10px" alt="remove">
        </a>
      </div>
        <div *ngFor="let doc of uploadedFiles; let i = index"
          class="attachment m-1 d-flex p-1 justify-content-between align-items-center">
          <div class="d-flex">
            <div title="Download" class="ml-2" (click)="downloadAttachment(doc)">
              <img src="design/images/paperclip.png" class="cursor-pointer" style="width: 20px;height:20px"
                alt="attachment">
            </div>
            <div class="mx-2 text-white">
              {{doc.fileName | replace }}
            </div>
          </div>
          <a class="me-2" (click)="delete(doc)" *ngIf="!isShareDocs">
            <img src="design/images/cancel.png" class="cursor-pointer" style="width: 10px;height:10px" alt="remove">
          </a>
        </div>
       

      </div>
      <eos-share-documents [candidateDocs]="candidateDocs" [moduleType]="moduleType" (attachClick)="ShareDocFn($event)"
        *ngIf="!isShareDocs"></eos-share-documents>

      <div *ngIf="showFileUploader" class="row">
        <form name="form" class="needs-validation col-6 p-0" #u="ngForm" novalidate>
          <div class="col-md-12 mb-3 ms-3 form-group">
            <label>Attach file</label>            
            <div class="input-group mb-3">
              <input [disabled]="disableUpload" #fileControl name="fileName" [(ngModel)]="fileDetails.fileName"
                type="file" (change)="fileSelected($event.target.files)" #fileName="ngModel"
                [accept]="fileBrowserAllowedTypes" style="display: none;">

              <input #fileField type="text" class="form-control form-control-sm readonly-date" readonly
                [value]="selectedFileName" [ngClass]="{ 'is-invalid': fileName.dirty && !selectedDocument }" required />
              <div class="input-group-append">
                <button type="button" [disabled]="disableUpload" (click)="browseFile()" class="btn-outline-primary">
                  Browse
                </button>
              </div>
              <div class="col-2">
                <button type="button" [disabled]="!selectedDocument || disableUpload" (click)="uploadDoc(u)"
                  class="btn btn-secondary btnAttach">
                  <span *ngIf="!disableUpload">Attach</span>
                  <span *ngIf="disableUpload" class="spinner m-3 reset-spinner-left"></span>
                </button>
              </div>
            </div>
            <div class="invalid-feedback">
              <span>
                File is required
              </span>
            </div>
          </div>

        </form>
      </div>
    </div>
    <div class="col-12 mt-3">
      <label>Message</label>
      <editor name="email" [init]="toolbarConfig" [(ngModel)]="results.content"></editor>
    </div>
    <div class="col-12 text-center mt-3 form-group">
      <button class="btn btn-outline-primary me-2" [disabled]="disableUpload" (click)="modal.dismiss()"
        onclick="javascript:return false;">Close</button>
      <button *ngIf="showSaveDraft" type="button" (click)="saveMailAsDraft(f)" class="btn btn-outline-primary me-2"
        [disabled]="!f.valid || isDisabled">Save
        as draft</button>

      <button class="btn btn-secondary" type="submit" [disabled]="!f.valid || isDisabled">Send</button>
    </div>
  </div>
</form>
